module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar', {
    attrs: {
      "back": "",
      "fixed": "",
      "bg": ""
    }
  }, [_c('span', {
    slot: "title"
  }, [_vm._v("企业文化")])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('scroller', {
    ref: "scroller",
    attrs: {
      "on-infinite": _vm.loadMore
    }
  }, [_c('div', {
    staticClass: "culture"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.cultureArticles), function(article, index) {
    return _c('router-link', {
      key: index,
      staticClass: "list-item clearfix",
      attrs: {
        "tag": "li",
        "to": ("/culture/article/" + (article.id))
      }
    }, [_c('div', {
      staticClass: "pull-left list-item-img"
    }, [_c('img', {
      attrs: {
        "src": article.bannerUrl,
        "alt": "article.title"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "pull-right list-item-content"
    }, [_c('h3', [_vm._v(_vm._s(article.title))]), _vm._v(" "), _c('p', {
      staticClass: "indent"
    }, [_vm._v(_vm._s(article.summary))]), _vm._v(" "), _c('div', {
      staticClass: "time text-right"
    }, [_vm._v("\n                " + _vm._s(article.addDate) + "\n              ")])])])
  }))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e665df1e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/culture.vue
// module id = 376
// module chunks = 1